import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductContent } from './components/ProductContent';
import { BonusSection } from './components/BonusSection';
import { PricingSelector } from './components/PricingSelector';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useMetaPixel('1927478928649366');
  return <div className="min-h-screen bg-deep-black text-smoke font-body selection:bg-electric-blue/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main className="pt-14 md:pt-[52px]" data-id="element-2">
        {' '}
        {/* Offset for fixed UrgencyBar */}
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <ProductContent data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSelector data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
      </main>

      <FooterSection data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
    </div>;
}